'use strict';
import "regenerator-runtime/runtime";
let React = require('react');
let BaseComponent = require('../../shared/base');
let client = require('../../../../sdk/client');

var toastr = require('toastr');

let OrderItemsTableComponent = require('../orders/order-items-table');


const sortTypes = {
    up: {
        class: 'sort-up'
    },
    down: {
        class: 'sort-down'
    },
    default: {
        class: 'sort'
    }

};

var pdfInvoices2 =  {};
var xmlInvoices2 =  {};

class TableInvoicesComponent extends BaseComponent {

    constructor(props) {
        super(props)

        this.state = {
            disp: 'none',
            data: [],
            detailsData: [],
            xmlInvoices: [],
            pdfInvoices: [],
            datamodal: [],
            currentSort: 'default',
            //    datatableinvoices: [],
            arrdataSupplyOrders: [],
            companyRFC: "DME870724367",
            customerRFC: "KOM970116SN8",
            //   datamodalEst: [],
            dataFreights: [],
            boolIsEstafeta: false
            
        }
        this.onSortChange = this.onSortChange.bind(this)
    }

    componentDidMount() {
        //this.setRFCs();
        this.setState({
            disp: 'block',
            //  datamodal:datatable,
            currentSort: 'default',
            //    datatableinvoices: request
        });

        this.getDataTrace();
    }

    onSortChange(attribute) {
        //  console.log(this.state.currentSort)
        //  console.log(attribute)
        let nextSort;
        var datat;
        if (this.state.currentSort === 'down') {
            nextSort = 'up';
            datat = this.state.arrdataSupplyOrders.sort((a, b) => {
                if (a[attribute] < b[attribute]) return -1;
                if (a[attribute] > b[attribute]) return 1;
                return 0;
            });
        } else if (this.state.currentSort === 'up') {
            nextSort = 'down';
            datat = this.state.arrdataSupplyOrders.sort((a, b) => {
                if (a[attribute] > b[attribute]) return -1;
                if (a[attribute] < b[attribute]) return 1;
                return 0;
            });
        }
        else if (this.state.currentSort === 'default') {
            nextSort = 'up';
            datat = this.state.arrdataSupplyOrders.sort((a, b) => {
                if (a[attribute] < b[attribute]) return -1;
                if (a[attribute] > b[attribute]) return 1;
                return 0;
            });
        }
        this.setState({
            currentSort: nextSort
            //    datatableinvoices: datat
        });
    };

    getTableData() {
        //Test OrderId: 5451133
        // console.log("in table");
        let self = this;
        client.InvoiceRequest.getOrderInvoices(this.props.orderId, 446, 1)//t 6198333. 
            .then((response) => {
                        // console.log("1");
                        // console.log("response after: " + response);
                if(response[0]) {
                                            // console.log("resp 2");
                    self.setState({ 
                        data: response[0].SupplyOrders,
                        detailsData: response[0].Details
                    }, () => {
                                                // console.log("resp 3");
                                                                        // console.log(response[0]);
                        self.loadInvoices(response[0].SupplyOrders, self.props.customerRFC)
                        self.saveSupplyOrders().then(response => {
                            // console.log("4");
                            // console.log(response);
                            let arrData = response;
                            for (let index = 0; index < arrData.length; index++) {
                                if(arrData[index]) {
                                    const element = arrData[index];
                                    if (element.carrierCode != "PERSON") {
                                        self.setUrlFreight(element.carrierCode);
                                    }
                                }
                            }
                        });
                    });
                }
            },
                (error) => {
                    // console.log(error);
                }
            );
    }

    getDataTrace() {
        if(this.props.customerRFC == undefined){
            return;
        }
        let self = this;
        client.TraceRecord.GetTraceRecords()
            .then(response => {
                // console.log("getDataTrace: " + response);
                let jsonResonse = JSON.parse(response);
                // console.log("jsonResonse: " + jsonResonse);

                self.setState({ dataFreights: jsonResonse.Records }, () => {
                    self.getTableData();
                });
            },
                (error) => {
                    console.log(error);

                });
    }

    setUrlFreight(code) {

        if (this.state.dataFreights.length) {

            for (let index = 0; index < this.state.dataFreights.length; index++) {
                if(this.state.dataFreights[index]) {
                    const element = this.state.dataFreights[index];
                    /*var active = element.IsActive == 1 ? true : false;
                    var apiEnabled = element.IsAPIEnabled == 1 ? true : false;
                    var name = element.DisplayName;*/

                    if (code == element.ExternalCode) {                  

                            if (code != "1ESTAFETA") {
                                if (element.URL != null) {
                                    var url = element.URL;

                                    if (url.includes("https://") || url.includes("http://")) { }
                                    else {
                                        url = "https://" + url;
                                    }
                                    let arrData = this.state.arrdataSupplyOrders;
                                    arrData[0].url = url.trim();
                                    this.setState({
                                        arrdataSupplyOrders: arrData,
                                    });

                                } else {
                                    toastr.error('La fletera no cuenta con la Url correcta.', 'Url Requerida');
                                    return;
                                }
                            } else {
                                    this.setState({
                                        boolIsEstafeta: true,
                                    });
                                }                        
                    }
                }
            }
        }



    }

    saveSupplyOrders() {
        return new Promise((resolve, reject) => {
            var arrdataSupplyOrders = [];
            var index = 0;
            //    var orderData = this.props.orderdata.SupplyOrders;
            //  console.log("save suply orders")
            // console.log(this.props.orderdata)

            this.state.data.map(function (itemSupplyOrder) {
                // console.log("itemSupplyOrder: " + itemSupplyOrder);
                var SupplyOrderTaxSubtotal = itemSupplyOrder.SupplyOrderAmount;
                var SupplyOrderSubtotal = SupplyOrderTaxSubtotal / (1 + itemSupplyOrder.Vat);
                var numberGuides = "";
                var carrierCode = "";

                if (itemSupplyOrder.Carrier.length == 1) {
                    numberGuides = itemSupplyOrder.Carrier[0].ShippingGuides
                    carrierCode = itemSupplyOrder.Carrier[0].CarrierCode
                } else {
                    for (let index = 0; index < itemSupplyOrder.Carrier.length; index++) {
                        if(itemSupplyOrder.Carrier[index]) {
                            const element = itemSupplyOrder.Carrier[index];
                            numberGuides += element.ShippingGuides + ",";
                            carrierCode = itemSupplyOrder.Carrier[index].CarrierCode
                        }
                    }

                }

                var dataSupplyOrders = {
                    indexSupplyOrder: "" + index,
                    SupplyOrderId: itemSupplyOrder.SupplyOrderId,
                    SupplyOrderDate: itemSupplyOrder.SupplyOrderDate,
                    /*      SupplyOrderInvoices: {
                        xmlFiles: this.state.xmlInvoices[index],
                        pdfFiles: this.state.pdfInvoices[index]
                    },*/

                    supplyOrderAmount: SupplyOrderSubtotal.toFixed(2),
                    SupplyOrderTaxSubtotal: SupplyOrderTaxSubtotal.toFixed(2),
                    shippingGuides: numberGuides,
                    carrierCode: carrierCode,
                    supplyOrderStatus: itemSupplyOrder.SupplyOrderStatus,
                    Invoices: itemSupplyOrder.Invoices != null ? itemSupplyOrder.Invoices : [],
                    Details: itemSupplyOrder.Details
                }
                index = index + 1;
                arrdataSupplyOrders.push(dataSupplyOrders)
            });
            this.setState({
                arrdataSupplyOrders: arrdataSupplyOrders
            });
            resolve(arrdataSupplyOrders);
        });
    }

    loadInvoices(dataSupplyOrder, customerRFC) {
        let xmlFiles = [];
        let pdfFiles = [];
        if(dataSupplyOrder) {
            // console.log('facs supply order');
            // console.log(dataSupplyOrder);
            dataSupplyOrder.forEach(itemOrder => {
                if (itemOrder.Invoices != null) {
                    itemOrder.Invoices.forEach(invoice => {
                        //   request.map(function (itemOrder) {
                        //client.InvoiceRequest.downloadInvoice("DME870724367", "AME831229C40", itemOrder.InvoiceSeries, itemOrder.InvoiceNumber, "XML")
                        // console.log(`Invoice number for ${this.props.orderId} = ${invoice.InvoiceNumber}`);
                        const promiseXML = client.InvoiceRequest.downloadInvoice(this.state.companyRFC, customerRFC, invoice.InvoiceSeries, invoice.InvoiceNumber, "XML");
                        const promisePDF = client.InvoiceRequest.downloadInvoice(this.state.companyRFC, customerRFC, invoice.InvoiceSeries, invoice.InvoiceNumber, "PDF");
                        Promise.all([promiseXML, promisePDF]).then( response => {
                            // console.log("promises")
                            // console.log(response);
                            if (response[0].Result !== 0) {
                                //alert(response[0].Message);
                            } else {
                                var text = "";
                                if(invoice.IsCore) {
                                    text = "data:application/xml;base64," + response[0].file;
                                    xmlFiles.unshift("data:application/xml;base64," + response[0].file);
                                    xmlInvoices2[invoice.InvoiceNumber + "Core"] = text;
                                } else {
                                    text = "data:application/xml;base64," + response[0].file;
                                    xmlFiles.push("data:application/xml;base64," + response[0].file)
                                    xmlInvoices2[invoice.InvoiceNumber] = text;
                                }

                                //  xmlFiles.push(response.file);
                                this.setState({
                                    xmlInvoices: xmlFiles
                                });
                            }

                            if (response[1].Result !== 0) {
                                //alert(response[1].Message);
                                // console.log(response[1]);
                            } else {
                                // console.log("invoice inside");
                                var text = "";
                                if(invoice.IsCore) {
                                    text = "data:application/pdf;base64," + response[1].file;
                                    pdfFiles.unshift("data:application/pdf;base64," + response[1].file)
                                    pdfInvoices2[invoice.InvoiceNumber + "Core"] = text;
                                } else {
                                    text = "data:application/pdf;base64," + response[1].file;
                                    pdfFiles.push("data:application/pdf;base64," + response[1].file)
                                    pdfInvoices2[invoice.InvoiceNumber] = text;
                                }
                                
                                this.setState({
                                    pdfInvoices: pdfFiles
                                });
                            }
                        });
                    })
                }
            });
        }
    }

    showModalOrderItems(ev) {
        var indexSupplyOrderr = ev.currentTarget.getAttribute("indexsupplyorder");

        var SupplyOrder = this.state.arrdataSupplyOrders.filter(function (n) {
            return n.indexSupplyOrder === indexSupplyOrderr
        });

        var classModal = ".modalOrderID-" + this.props.orderId;
        this.setState({ datamodal: SupplyOrder[0].Details });

      /*  $(classModal).modal("show")
        if ($('.modal-backdrop').is(':visible')) {
            $('.modal-backdrop').removeClass('modal-backdrop');
        };*/

        this.props.updateDataModalSupplyOrders(SupplyOrder[0].Details)

    }

    renderIconsInvoice(supplyOrderInvoices, nameFile, xmlFile, pdfFile) {
        if (supplyOrderInvoices) {
            return <div key={supplyOrderInvoices.InvoiceNumber}>
                <a download={nameFile} href={xmlFile}
                    className="btn_delete_act">
                    <i className="icon" style={{ backgroundImage: 'url(/assets/images/bepensa/xml_icon.svg)' }}></i>
                </a>
                <a download={nameFile} href={pdfFile}
                    className="btn_delete_act">
                    <i className="icon" style={{ backgroundImage: 'url(/assets/images/bepensa/pdf_icon.svg)' }}></i>
                </a>
            </div>
        } else {
            return <div></div>
        }
    }

    showModalEstafeta(ev) {

        var shippingGuides = ev.currentTarget.getAttribute("shippingguides");
        //shippingGuides = shippingGuides.substring(0, shippingGuides.length - 1);
        var onlyGuide = ev.target.attributes.getNamedItem('data-tag').value;
        let arrTraceEstafeta = [];
        var index = 0;
        client.TraceRecord.GetTrackingEstafeta(shippingGuides).then(response => {

            let jsonResponse = JSON.parse(response);

            if (jsonResponse.ExecuteQueryResult.errorCode == 0) {
                var dataDetails = {};

                if (jsonResponse.ExecuteQueryResult.trackingData.TrackingData.length == undefined) {
                    dataDetails = {
                        errorCode: jsonResponse.ExecuteQueryResult.errorCode,
                        waybillId: jsonResponse.ExecuteQueryResult.trackingData.TrackingData.waybill,
                        status: jsonResponse.ExecuteQueryResult.trackingData.TrackingData.statusSPA,
                        History: jsonResponse.ExecuteQueryResult.trackingData.TrackingData.history.History,
                    }

                } else {

                    for (let index = 0; index < jsonResponse.ExecuteQueryResult.trackingData.TrackingData.length; index++) {
                        if (jsonResponse.ExecuteQueryResult.trackingData.TrackingData[index].waybill == onlyGuide.trim()) {
                            dataDetails = {
                                indexDetail: "" + index,
                                errorCode: jsonResponse.ExecuteQueryResult.errorCode,
                                waybillId: jsonResponse.ExecuteQueryResult.trackingData.TrackingData[index].waybill,
                                status: jsonResponse.ExecuteQueryResult.trackingData.TrackingData[index].statusSPA,
                                History: jsonResponse.ExecuteQueryResult.trackingData.TrackingData[index].history.History,
                            }
                        }
                    }
                }
                arrTraceEstafeta.push(dataDetails)
            } else {
                index = index + 1;
                dataDetails = {
                    errorCode: "01",
                    waybillId: "",
                    status: "No existe información sobre el número de guía seleccionado",
                    History: ""
                }
                arrTraceEstafeta.push(dataDetails)
            }

          //  this.setState({ datamodalEst: arrTraceEstafeta });
           // $('#modalEstafeta').modal("show")

            this.props.updateDataModalSupplyOrders(arrTraceEstafeta)

        });

    }

    populateTableInvoice() {
        //if (this.state.data.orders.length) {
        //  if (this.state.datatableinvoices.length) {itemSupplyOrder.Carrier
        // console.log("length: " + this.state.arrdataSupplyOrders.length);
        // console.log("arrdataSupplyOrders:" + this.state.arrdataSupplyOrders);

        if (this.state.arrdataSupplyOrders.length) {
            var index = 0;
            //hardcode para probar modal
            // this.state.boolIsEstafeta = true
            //  return this.state.data.orders.map(function (itemOrder) {
            return this.state.arrdataSupplyOrders.map(function (itemOrder) {
                var orderCore = -1;
                if(Array.isArray(itemOrder.Invoices)) {
                    orderCore = itemOrder.Invoices.findIndex(x => x.IsCore);
                }
                // console.log("orderCore: " + orderCore);
                if(orderCore >= 0){
                    if(itemOrder.Invoices[0]) {
                        let temp = itemOrder.Invoices[0];
                        itemOrder.Invoices[0] = itemOrder.Invoices[orderCore];
                        itemOrder.Invoices[orderCore] = temp;

                        var date = "";
                        if (itemOrder.Invoices.InvoiceDate != undefined) {
                            date = itemOrder.Invoices.InvoiceDate.split('T');
                        }

                        var subTotalCore = 0;

                        if(itemOrder.Details) {
                            itemOrder.Details.forEach(detail => {
                                subTotalCore = subTotalCore + detail.SubTotalCoreAmount;
                            })
                        }

                        var TaxCore = subTotalCore * 0.16

                        var dateinvoice = itemOrder.SupplyOrderDate.split('T');
                        var xmlFileCore = this.state.xmlInvoices[index];
                        var pdfFileCore = this.state.pdfInvoices[index];
                        var nameFileCore = "" + dateinvoice[0] + " " + itemOrder.Invoices[0].InvoiceId;
                        var xmlFile = this.state.xmlInvoices[index+1];
                        var pdfFile = this.state.pdfInvoices[index+1];
                        var nameFile = "" + dateinvoice[0] + " " + itemOrder.Invoices[1].InvoiceId;
                        index = index + 2;
                        // console.log("PdfFile");
                        // console.log(itemOrder.Invoices[1].InvoiceNumber + " " + itemOrder.SupplyOrderId);
                        // console.log("Core");
                        // console.log(pdfInvoices2[itemOrder.Invoices[0].InvoiceNumber + "Core"]);
                        // console.log(pdfFileCore);
                        // console.log("Normal");
                        // console.log(pdfInvoices2[itemOrder.Invoices[1].InvoiceNumber]);
                        // console.log(pdfFile);
                        return <React.Fragment>
                            <tr key={itemOrder.SupplyOrderId + "_Core"} id="Core">
                                <td style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} onClick={(e) => this.showModalOrderItems(e)} indexsupplyorder={itemOrder.indexSupplyOrder}>{itemOrder.SupplyOrderId}</td>
                                <td>{dateinvoice[0]}</td>
                                <td>
                                    {this.renderIconsInvoice(itemOrder.Invoices[0], nameFileCore, xmlFileCore, pdfInvoices2[itemOrder.Invoices[0].InvoiceNumber + "Core"])}
                                </td>
                                <td>${(subTotalCore).toFixed(2)}</td>
                                <td>${(subTotalCore + TaxCore).toFixed(2)}</td>
                                {this.state.boolIsEstafeta == true &&
                                    <td style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} onClick={(e) => this.showModalEstafeta(e)} shippingguides={itemOrder.shippingGuides}>
                                        {this.renderFormatGuide(itemOrder.shippingGuides, "", "modal")}
                                    </td>
                                }
                                {this.state.boolIsEstafeta != true &&
                                    <td style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} shippingguides={itemOrder.shippingGuides}>
                                        {this.renderFormatGuide(itemOrder.shippingGuides, itemOrder.url, "url")}
                                    </td>
                                }
                                <td>{itemOrder.supplyOrderStatus}</td>
                            </tr>
                            <tr key={itemOrder.SupplyOrderId} id="Core1">
                                <td style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} onClick={(e) => this.showModalOrderItems(e)} indexsupplyorder={itemOrder.indexSupplyOrder}>{itemOrder.SupplyOrderId}</td>
                                <td>{dateinvoice[0]}</td>
                                <td>
                                    {this.renderIconsInvoice(itemOrder.Invoices[1], nameFile, xmlFile, pdfInvoices2[itemOrder.Invoices[1].InvoiceNumber])}
                                </td>
                                <td>${(itemOrder.supplyOrderAmount - subTotalCore).toFixed(2)}</td>
                                <td>${(itemOrder.SupplyOrderTaxSubtotal - TaxCore - subTotalCore).toFixed(2)}</td>
                                {this.state.boolIsEstafeta == true &&
                                    <td style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} onClick={(e) => this.showModalEstafeta(e)} shippingguides={itemOrder.shippingGuides}>
                                        {this.renderFormatGuide(itemOrder.shippingGuides, "", "modal")}
                                    </td>
                                }
                                {this.state.boolIsEstafeta != true &&
                                    <td style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} shippingguides={itemOrder.shippingGuides}>
                                        {this.renderFormatGuide(itemOrder.shippingGuides, itemOrder.url, "url")}
                                    </td>
                                }
                                <td>{itemOrder.supplyOrderStatus}</td>
                            </tr>
                        </React.Fragment>;
                    }
                } else {              
                    var date = "";
                    if(itemOrder.Invoices.length > 0) {
                        if (itemOrder.Invoices[0].InvoiceDate != undefined) {
                            date = itemOrder.Invoices[0].InvoiceDate.split('T');
                        }
                        var dateinvoice = itemOrder.SupplyOrderDate.split('T');
                        var xmlFile = this.state.xmlInvoices[index];
                        var pdfFile = this.state.pdfInvoices[index];
                        var nameFile = "" + dateinvoice[0] + " " + itemOrder.Invoices[0].InvoiceId;
                        index = index + 1;

                        // console.log("PdfFile");
                        // console.log(itemOrder.Invoices[0].InvoiceNumber + " " + itemOrder.SupplyOrderId);
                        // console.log("Normal");
                        // console.log(pdfInvoices2[itemOrder.Invoices[0].InvoiceNumber]);
                        // console.log(pdfFile);
                        return <tr key={itemOrder.SupplyOrderId} id="NoCore">
                            <td style={{color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8'}}
                                onClick={(e) => this.showModalOrderItems(e)}
                                indexsupplyorder={itemOrder.indexSupplyOrder}>{itemOrder.SupplyOrderId}</td>
                            <td>{dateinvoice[0]}</td>

                            <td>
                                {this.renderIconsInvoice(itemOrder.Invoices[0], nameFile, xmlFile, pdfInvoices2[itemOrder.Invoices[0].InvoiceNumber])}
                            </td>

                            <td>${itemOrder.supplyOrderAmount}</td>
                            <td>${itemOrder.SupplyOrderTaxSubtotal}</td>

                            {this.state.boolIsEstafeta == true &&
                                <td style={{color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8'}}
                                    onClick={(e) => this.showModalEstafeta(e)}
                                    shippingguides={itemOrder.shippingGuides}>
                                    {this.renderFormatGuide(itemOrder.shippingGuides, "", "modal")}
                                </td>
                            }

                            {this.state.boolIsEstafeta != true &&
                                <td style={{color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8'}}
                                    shippingguides={itemOrder.shippingGuides}>
                                    {this.renderFormatGuide(itemOrder.shippingGuides, itemOrder.url, "url")}
                                </td>
                            }
                            <td>{itemOrder.supplyOrderStatus}</td>
                        </tr>;
                    }
                }
            }, this);
        } else {
            // console.log("Else 1");

            return <tr id="Nothing">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>;
        }
    }

    renderFormatGuide(guide, url, type) {
        if (type == "modal" && guide != undefined) {
            if (!guide.includes(",")) {
                return (
                    <a data-tag={guide} style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} href={null}>{guide}</a>
                );
            } else {
                guide = guide.substring(0, guide.length - 1);
                let arrGuides = guide.split(",");

                return arrGuides.map(function (guideElement) {

                    return (
                        <a data-tag={guideElement} style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} href={null} id={guideElement} >{guideElement + '  '}</a>
                    )
                });

            }
        } else {
            if (url != null || url != undefined) {
                if (guide != null && !guide.includes(",")) {
                    var urlFormated = url.replace("@", guide).trim();
                    return (
                        <a target="_blank" data-tag={guide} style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} href={urlFormated} id={guide} >{guide}</a>
                    );

                } else {
                    if (
                        guide == null
                        )
                    {
                        return <div></div>
                    }
                    else 
                    {
                        guide = guide.substring(0, guide.length - 1);
                        let arrGuides = guide.split(",");
                        var urlFormated = "";

                        return arrGuides.map(function (guideElement) {
                            urlFormated = url.replace("@", guideElement);
                            return (
                                <a target="_blank" data-tag={guideElement} style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} href={urlFormated} id={guideElement} >{guideElement + '  '}</a>
                            )
                        });
                    }
                }
            }
        }
    }

    renderHeadersort() {
        if (typeof this.renderCustomHeader == 'function') return this.renderCustomHeader();
        return (
            <thead>
                <tr>
                    <th>Orden de surtido<button className="btnsort" onClick={this.onSortChange.bind(this, "SupplyOrderId")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Fecha<button className="btnsort" onClick={this.onSortChange.bind(this, "SupplyOrderDate")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Factura <i className="icondownload" /></th>
                    <th>Importe<button className="btnsort" onClick={this.onSortChange.bind(this, "supplyOrderAmount")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Importe facturado<button className="btnsort" onClick={this.onSortChange.bind(this, "SupplyOrderTaxSubtotal")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Num. guía<button className="btnsort" onClick={this.onSortChange.bind(this, "shippingguides")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Estatus<button className="btnsort" onClick={this.onSortChange.bind(this, "supplyOrderStatus")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                </tr>
            </thead>
        );
    }

    renderHeader2() {
        if (typeof this.renderCustomHeader == 'function') return this.renderCustomHeader();
        return (
            <div id="containerHeaderTable">
                <div className="container-headert" style={{ width: '15%' }}><label className="headert">Orden de surtido</label></div>
                <div className="container-headert" style={{ width: '10%' }}><label className="headert">Fecha</label></div>
                <div className="container-headert" style={{ width: '10%' }}><label className="headert">Factura</label></div>
                <div className="container-headert" style={{ width: '10%' }}><label className="headert">Importe</label></div>
                <div className="container-headert" style={{ width: '16%' }}><label className="headert">Importe facturado</label></div>
                <div className="container-headert" style={{ width: '12%' }}><label className="headert">Num. guía</label></div>
                <div className="container-headert" style={{ width: '10%' }}><label className="headert">Estatus</label></div>
            </div>
        );
    }



    renderTableInvoice() {
        return (
            <div id="invoiceTable" className="subaccount-data-table table-responsive" style={{ display: this.state.disp, maxHeight: '420' }}>
                <span>Id de referencia: <strong>{this.props.orderId}</strong></span>
                <table id="TinvoiceTable" className="table-scroll table sub-account tb-left clickable">
                    {this.renderHeadersort()}
                    <tbody className="bodytb-invoice">
                        {this.populateTableInvoice()}
                    </tbody>
                </table>
                <div>
                   {/* <OrderItemsTableComponent orderId={this.props.orderId} datatable={this.state.datamodal} dataestafeta={this.state.datamodalEst} /> */}
                </div>
            </div>

        );
    }

    subTryToLoadBackOrder(
        boolLoadPrices_I
    )
    {
        if (
            this.state.data !== undefined
            )
        {
            this.renderLinktoBackOrder();
            // console.log("Se cargó link backorder")
        }
        else 
        {
            setTimeout( () => {
                this.subTryToLoadBackOrder();
            }, 1000)
        }
    }

    renderLinktoBackOrder() {
        var bandLink = false;
        var self = this;
        
        if (self.state.detailsData) {

            self.state.detailsData.map(function (detail) {

                if (detail.BackOrderQuantity > 0)
                    bandLink = true;
            }, this);
        }

        if (bandLink) {
            return (
                <a target="_blank" style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }} href={"/backorders?orderID=" + self.props.orderId}>Ver detalles en BackOrders</a>
            );
        }
    }

    render() {
        return (
            <React.Fragment>
                {/*this.renderHeader2()*/}
                {this.renderTableInvoice()}
                {this.renderLinktoBackOrder()}
                {/*<a target="_blank" style={{color:'#009edf', fontWeight:'bold', textDecoration:'underline #17A2B8'}} href={"/backorders?orderID="+this.state.orderID}>Ver detalles en BackOrders</a>*/}
            </React.Fragment>
        );
    }
}

module.exports = TableInvoicesComponent;